import { OndigoNS } from '../modules/main.js';
import $ from 'jquery';
window.$ = window.jQuery = $;

(function ($) {
    'use strict';

    // class definition
    OndigoNS.ConditionalScripts = function () {
        this.init();
    };

    OndigoNS.ConditionalScripts.prototype = {
        init: function () {

            if ($('.map').length && window.screen.availWidth >= OndigoNS.breakpointWide) {
                this.loadScript('/typo3conf/ext/sitepackage/Resources/Public/Js/ConditionalScripts/gmapScripts.js', function() {
                });
            }
        },

        loadCss : function loadCSS( href, before, media ){

            var ss = window.document.createElement( 'link' );
            var ref = before || window.document.getElementsByTagName( 'script' )[ 0 ];
            ss.rel = 'stylesheet';
            ss.href = href;
            ss.media = 'only x';
            ref.parentNode.insertBefore( ss, ref );
            setTimeout( function(){
                ss.media = media || 'all';
            } );
        },

        loadScript : function (url, callback) {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            if (script.readyState) {
                script.onreadystatechange = function () {
                    if (script.readyState === 'loaded' || script.readyState === 'complete') {
                        script.onreadystatechange = null;
                        if (callback && typeof callback === 'function') {
                            callback();
                        }
                    }
                };
            } else {
                script.onload = function () {
                    if (callback && typeof callback === 'function') {
                        callback();
                    }
                };
            }
            script.src = url;
            (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
        },
    };

    // plugin definition
    $.fn.conditionalScripts = function () {
        return new OndigoNS.ConditionalScripts();
    };
    $.fn.conditionalScripts.Constructor = OndigoNS.ConditionalScripts;

}(window.jQuery));



$(document).ready(function () {
    'use strict';

    $.fn.conditionalScripts();
});
